import React from "react";
import {Link} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import PropTypes from 'prop-types';
import {
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import styled from "@emotion/styled";

const StyledTableCell = styled((props) => (
    <TableCell {...props}/>
))(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.appBar.dark,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        backgroundColor: theme.palette.background.paper,
    },
}));

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    caption: {
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        borderRadius: '4px 4px 0px 0px',
        backgroundColor: theme.palette.appBar.dark,
        color: theme.palette.primary.contrastText,
    },
    container: {
        background: `linear-gradient(180deg, ${theme.palette.appBar.dark} 10%, ${theme.palette.background.paper} 90%)`,
        maxHeight: '65vh',
    },
    link: {
        textDecoration: "none",
        cursor: "pointer",
        color: theme.palette.text.primary,
    },
}));

export default function PivanTable(props) {
    const classes = useStyles();
    const {
        caption,
        columns,
        rows,
    } = props;

    return (
        <div className={classes.root}>
            {caption &&
                <Typography variant="h6" className={classes.caption}>
                    {caption}
                </Typography>}
            {columns && rows && <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <StyledTableCell
                                    key={column.key}
                                    align={column.align}
                                    style={{minWidth: column.minWidth}}
                                >
                                    {column.label}
                                </StyledTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                    {columns.map((column) => {
                                        const value = row[column.id];
                                        let render;
                                        if (column.linkAction !== undefined) {
                                            render = <div onClick={event => column.linkAction(event, row)}
                                                          className={classes.link}>
                                                {column.render !== undefined ? column.render(value) : value}
                                            </div>
                                        } else if (column.linkPath !== undefined) {
                                            render = <Link to={column.linkPath(row)} className={classes.link}>
                                                {column.render !== undefined ? column.render(value) : value}
                                            </Link>
                                        } else {
                                            render = <>{column.render !== undefined ? column.render(value) : value}</>
                                        }
                                        return (
                                            <StyledTableCell key={`${column.key}${row.id}`} align={column.align}>
                                                {render}
                                            </StyledTableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>}
        </div>
    );
}

PivanTable.propTypes = {
    caption: PropTypes.string,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
                key: PropTypes.string.isRequired,
                id: PropTypes.string.isRequired,
                label: PropTypes.any.isRequired,
                linkPath: PropTypes.func,
                linkAction: PropTypes.func,
                render: PropTypes.func,
                minWidth: PropTypes.number
            }
        ),
    ).isRequired,
    rows: PropTypes.array.isRequired
}